import { render, staticRenderFns } from "./FirmwareVersionPieChart.vue?vue&type=template&id=33b23c06"
import script from "./FirmwareVersionPieChart.vue?vue&type=script&lang=js"
export * from "./FirmwareVersionPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports